<div
  *ngIf="tabsData"
  [ngClass]="tabTheme === 'grey' ? 'tabs__wrapper--grey' : ''"
  [edsSpacing]="spacingBottom"
>
  <div edsGrid>
    <div [class]="containerClass">
      <eds-tabs
        [followFocus]="true"
        [isNavigation]="true"
        [cacheActive]="true"
        [vertical]="tabsType === 'vertical'"
        [darkBackground]="tabTheme === 'grey'"
      >
        <ng-container *ngFor="let tab of tabsData">
          <eds-tab [heading]="tab.tabTitle" [tabId]="tab.tabIdField">
            <ng-container
              *ngFor="let contentBlock of tab.tabContent"
              [ngSwitch]="contentBlock.contentType"
            >
              <ng-template ngSwitchCase="ftcore:ContentBlock">
                <ft-one-col-block
                  [contentBlock]="contentBlock"
                  [page]="page"
                ></ft-one-col-block>
              </ng-template>
              <ng-template ngSwitchCase="ftcore:TwoColumnBlock">
                <ft-two-col-block
                  [contentBlock]="contentBlock"
                  [page]="page"
                ></ft-two-col-block>
              </ng-template>
              <ng-template ngSwitchCase="ftcore:CardGroupCompound">
                <ng-container
                  *ngIf="
                    contentBlock.sectionType === 'media_cards' ||
                    contentBlock.sectionType === 'media_cards_list'
                  "
                >
                  <ft-tabs-media-cards-section
                    [content]="contentBlock"
                    [page]="page"
                  ></ft-tabs-media-cards-section>
                </ng-container>
                <ng-container
                  *ngIf="contentBlock.sectionType === 'media_card_index'"
                >
                  <ft-tabs-media-cards-index
                    [content]="contentBlock"
                    [page]="page"
                  ></ft-tabs-media-cards-index>
                </ng-container>
                <ng-container
                  *ngIf="
                    contentBlock.sectionType === 'thumbnail_cards' ||
                    contentBlock.sectionType === 'thumbnail_cards_compact'
                  "
                >
                  <ft-tabs-thumbnails-section
                    [content]="contentBlock"
                    [page]="page"
                  ></ft-tabs-thumbnails-section>
                </ng-container>
              </ng-template>
            </ng-container>
          </eds-tab>
        </ng-container>
      </eds-tabs>
    </div>
  </div>
</div>
